import React, { useState } from "react";
import FormBuilder from "../../../class/tool/FormBuilder";

const SellerBarcodesFormSheet = props => {
    const { object, values, storeSettings, errors, updated, setGlobalError, handleChange, handleRecovery, handleSave } = props
    const [ rows, setRows ] = useState([
        {
            label: "",
            attribute: "barcode",
            returnType: "barcode",
            inputType: "barcode",
            classnameLabel: "label",
            classnameNoInput: "",
            emptyText: "",
            storeSettings: storeSettings,
            readOnly: false
        }
    ])

    const buildRow = row => {
        return FormBuilder.buildInputByType(row, values, errors, change, null, recovery)
    }
    const change = (attribute, returnType, val) => {
        handleChange(rows, attribute, returnType, val, false)
    }
    const recovery = (idPricelist, type, mainPrice) => {
        handleRecovery(idPricelist, type, mainPrice)
    }
    const handleSubmit = event => {
        if (event !== undefined)
            event.preventDefault()
        handleSave()
    }

    return (
        <form
            className={"form inOverbox"}
            onSubmit={ handleSubmit }>
            {
                rows.map((row, index) => (
                    <div key={ index } className="clearing">
                        {
                            buildRow(row)
                        }
                    </div>
                ))
            }
        </form>
    )
}

export default SellerBarcodesFormSheet
